import { useState } from 'react';

import Popover from 'ui/Popover';

import ActionMenuTriggerButton from './ActionMenuTriggerButton';

type Props = {
  children: React.ReactNode;
  label: string;
  disabled?: boolean;
};

const PopoverButton: React.FC<Props> = ({ children, label, disabled }) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover.Root
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
      positioning={{ gutter: 0, placement: 'bottom-start' }}
    >
      <Popover.Trigger>
        <ActionMenuTriggerButton
          disabled={disabled}
          onClick={() => setOpen(!open)}
        >
          {label}
        </ActionMenuTriggerButton>
      </Popover.Trigger>
      <Popover.Content borderColor="gray.400" w="330px">
        <Popover.Body p={3}>{children}</Popover.Body>
      </Popover.Content>
    </Popover.Root>
  );
};

export default PopoverButton;
